import { get, post, del } from '../lib/apiClient';

/** GET /domains */
export const listDomains = () => get('/domains');

/** POST /domains/setup */
export const setupDomain = (domain, role) =>
  post('/domains/setup', role ? { domain, role } : { domain });

/** GET /domains/{domainId} */
export const getDomainStatus = domainId => get(`/domains/${encodeURIComponent(domainId)}`);

/** POST /domains/{domainId}/verify */
export const verifyDomain = domainId => post(`/domains/${encodeURIComponent(domainId)}/verify`);

/** DELETE /domains/{domainId} */
export const removeDomain = domainId => del(`/domains/${encodeURIComponent(domainId)}`);

/**
 * GET /domains/resolve - no auth. Which org, and which of its hosts
 * (website or portal), a custom domain is (docs/Decisions.md D60 item 4).
 */
export const resolveDomain = domain => get('/domains/resolve', { auth: false, query: { domain } });

/** POST /domains/hosts - the website and portal hosts on the org's domain (D56, D60). */
export const setupHosts = body => post('/domains/hosts', body);

/** POST /domains/{domainId}/rename - `{ domain, scheduledAt? }` (D56 item 3). */
export const renameDomain = (domainId, body) =>
  post(`/domains/${encodeURIComponent(domainId)}/rename`, body);

/** DELETE /domains/{domainId}/rename */
export const cancelRename = domainId => del(`/domains/${encodeURIComponent(domainId)}/rename`);
